<template>
    <el-container class="mainJjglxxBody">
        <div class="divTab">
            <el-table
                    :data="tableData"
                    style="width: 100%"
                    :header-cell-class-name="ClassName_Biaotou"
                    :row-class-name="tableRowClassName">
                <el-table-column
                        prop="jgmc"
                        align="center"
                        label="企业名称"
                        width="260">
                </el-table-column>
                <el-table-column
                        prop="babh"
                        align="center"
                        label="标准"
                        >
                </el-table-column>
                <el-table-column
                        prop="lxdh"
                        align="center"
                        label="信用分"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="mddz"
                        align="center"
                        label="日期"
                        width="180">
                </el-table-column>
            </el-table>
        </div>
    </el-container>
</template>

<script>
    export default {
        name: "jjjggs_cx",
        data() {
            const item = {
                jgmc: '汉中鸿润置业有限公司',
                babh: '房地产经纪机构备案初始分80。',
                lxdh: '10',
                mddz:'2021-02-27',
            };
            return {
                tableData: Array(3).fill(item),
                JjjgxxList:{
                    JGMC:'汉中鸿润置业有限公司',
                    GSDZ:'汉中市汉台区汉中颐高互联网双创园',
                    BAZH:'某某',
                },
            }
        },
        methods: {
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            tableRowClassName({row, rowIndex}) {
                if ( rowIndex%2 ==0) {
                    return 'success-row';
                } else if (rowIndex%2 !=0) {
                    return '';
                }
                return '';
            },
            ClassName_Biaotou({row, column, rowIndex, columnIndex}) {
                return 'class_Biaotou';
            },
        },
    }
</script>

<style scoped>
    @import "../../assets/css/jjgl/jjglxx_main.css";
</style>